import React from "react";

import { InputPicker, Toggle } from "rsuite";
import MinusIcon from "@rsuite/icons/Minus";

const BedExitForm = ({
    bedExit24Hours,
    bedExitRangeData,
    handleChange,
    bedExitFrom,
    bedExitTo,
    bedExitDisabled,
    bedExitData,
    bedExitMinutes,
    handleResetDefaultBedExit}) => {

    return (<div className="col-md-6">
        <div className="card">
            <div className="card-header">
                Bed Exit
            </div>

            <div className="card-body px-0 py-0 bed-exit">
                <section>
                    <div className="row">
                        <div className="col-md-12">
                            <label>
                                <div>
                                    Bed Occupancy Time
                                    <small>
                                        Set the time range the <strong>resident will be in bed</strong>
                                    </small>
                                </div>
                            </label>
                        </div>
                        <div className="col-md-4">
                            All Day&nbsp;
                            <Toggle  className="settings-group" checked={bedExit24Hours || false} onChange={(value) => handleChange("setting.bedexit.allday", value)} />
                        </div>

                        <div className="col-md-8">
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <InputPicker data={bedExitRangeData}
                                    disabled={bedExit24Hours}
                                    placeholder={"Select time"}
                                    className="settings-group"
                                    style={{ width: "125px" }}
                                    onChange={(value) => handleChange("setting.bedexit.rangestart_timeofday", value)}
                                    value={bedExitFrom} />
                                <MinusIcon style={{ margin: "0px 5px" }} />
                                <InputPicker data={bedExitRangeData}
                                    disabled={bedExit24Hours}
                                    className="settings-group"
                                    style={{ width: "125px" }}
                                    placeholder={"Select time"}
                                    onChange={(value) => handleChange("setting.bedexit.rangeend_timeofday", value)}
                                    value={bedExitTo} />
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="row">
                        <div className="col-md-12">
                            <div style={{ marginBottom: "20px" }}>
                                Bed Exit Timer&nbsp;
                                <Toggle  className="settings-group" checked={bedExitDisabled || false} onChange={(value) => handleChange("setting.bedexit.active", value)} />
                            </div>
                        </div>
                        <div className="col-md-8">
                            <label>
                                <small>
                                    Alert me if the resident has been <strong>out of the bed</strong> within the bed occupancy time for over
                                </small>
                            </label>
                        </div>
                        <div className="col-md-4">

                            <InputPicker data={bedExitData}
                                disabled={!bedExitDisabled}
                                className="settings-group"
                                placeholder={"Select time"}
                                onChange={(value) => handleChange("setting.bedexit.span", value)}
                                value={bedExitMinutes} />
                        </div>
                    </div>
                </section>
            </div>
            <div className="card-footer text-right">
                <button className="btn btn-secondary" onClick={handleResetDefaultBedExit}>Return to Default</button>
            </div>
        </div>
    </div>
    );
}

BedExitForm.defaultProps = {
    bedExit24Hours: null,
    bedExitRangeData:null,
    bedExitFrom:null,
    bedExitTo:null,
    bedExitDisabled:false,
    bedExitData:null,
    bedExitMinutes:null,
}

export default BedExitForm;